export const POSTCODE_MAX_LENGTH = 15;
export const POSTCODE_MIN_LENGTH = 3;
export const POSTCODE_REGEXP = /^[a-zA-Z\d\s-]*$/m;

export const validationPostcodeRules = {
  pattern: {
    value: POSTCODE_REGEXP,
    message: 'validation.wrongSymbols'
  },
  maxLength: {
    value: POSTCODE_MAX_LENGTH,
    message: 'validation.valueLongerThan15'
  },
  minLength: {
    value: POSTCODE_MIN_LENGTH,
    message: 'validation.valueShorterThan3'
  }
};
